import React, { useEffect, useRef } from 'react'
import Modal from 'react-modal'
import PlayAll from '../modals/PlayAll'
import useStore from 'state/knovStore'
import { getPlayThreadUrl, insertToClipboard } from 'utils'

Modal.setAppElement('#knovigator-body')

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(3, 6, 12, 0.98)',
        zIndex: 1500,
    },
    content: {
        inset: 0,
        width: '100%',
        padding: 0,
        border: 'none',
        background: '#04070d',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        paddingTop: 'var(--modal-safe-area-top)',
        paddingRight: 'var(--modal-safe-area-right)',
        paddingBottom: 'var(--modal-safe-area-bottom)',
        paddingLeft: 'var(--modal-safe-area-left)',
        overflow: 'hidden',
    },
}

export default function StoryModal(props) {
    const isStoryOpen = useStore(state => state.isStoryOpen)
    const closeStoryModal = useStore(state => state.actions.modalActions.closeStoryModal)
    const activeModalParams = useStore(state => state.modalParams)
    const initialStoryModalParams =
        activeModalParams?.type === 'PlayAll' ? activeModalParams : props.modalParams || null
    const [storyModalParams, setStoryModalParams] = React.useState(initialStoryModalParams)
    const resolvedStoryModalParams =
        storyModalParams || (activeModalParams?.type === 'PlayAll' ? activeModalParams : null)
    const copyButtonRef = useRef(null)
    const copyIconRef = useRef(null)
    const copyResetTimeoutRef = useRef(null)

    useEffect(() => {
        return () => {
            if (copyResetTimeoutRef.current) {
                window.clearTimeout(copyResetTimeoutRef.current)
            }
        }
    }, [])

    React.useEffect(() => {
        if (!isStoryOpen) {
            setStoryModalParams(null)
            return
        }

        if (activeModalParams?.type === 'PlayAll') {
            setStoryModalParams(activeModalParams)
        }
    }, [activeModalParams, isStoryOpen])

    const close = () => {
        closeStoryModal()
    }

    const copyPlayThreadUrl = e => {
        e?.preventDefault?.()
        e?.stopPropagation?.()
        insertToClipboard(getPlayThreadUrl())

        if (copyResetTimeoutRef.current) {
            window.clearTimeout(copyResetTimeoutRef.current)
        }

        if (copyButtonRef.current) {
            copyButtonRef.current.title = 'Copied play URL'
        }

        if (copyIconRef.current) {
            copyIconRef.current.className = 'fa fa-check'
        }

        copyResetTimeoutRef.current = window.setTimeout(() => {
            if (copyButtonRef.current) {
                copyButtonRef.current.title = 'Copy play thread URL'
            }

            if (copyIconRef.current) {
                copyIconRef.current.className = 'fa fa-link'
            }
        }, 1500)
    }

    /** @type {React.CSSProperties} */
    const actionButtonStyle = {
        cursor: 'pointer',
        display: 'flex',
        width: '38px',
        height: '38px',
        borderRadius: '999px',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'rgba(245, 247, 251, 0.96)',
        background: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.14)',
        fontSize: '18px',
        textAlign: 'center',
    }

    return (
        <Modal
            isOpen={isStoryOpen}
            onRequestClose={closeStoryModal}
            style={customStyles}
            contentLabel="Knov Modal"
        >
            <div
                style={{
                    position: 'absolute',
                    display: 'flex',
                    top: 'calc(22px + var(--modal-safe-area-top))',
                    right: 'calc(24px + var(--modal-safe-area-right))',
                    gap: '10px',
                    zIndex: '1000',
                }}
            >
                <div
                    ref={copyButtonRef}
                    style={actionButtonStyle}
                    onClick={copyPlayThreadUrl}
                    title="Copy play thread URL"
                >
                    <i ref={copyIconRef} className="fa fa-link" />
                </div>

                <div style={actionButtonStyle} onClick={close} title="Close play thread">
                    <i className="fa fa-close" />
                </div>
            </div>

            <div
                style={{
                    alignSelf: 'center',
                    width: '100%',
                    flex: 1,
                    minHeight: 0,
                }}
            >
                {getModalContent(resolvedStoryModalParams, closeStoryModal)}
            </div>
        </Modal>
    )
}

function getModalContent(modalParams, closeModal) {
    if (!modalParams) return null

    switch (modalParams.type) {
        case 'PlayAll':
            return (
                <PlayAll
                    modalParams={modalParams}
                    closeModal={closeModal}
                    height={'100%'}
                    width={'100%'}
                />
            )
    }
}
